// extracted by mini-css-extract-plugin
module.exports = {"cat-heading":"fbt-mobile-drawer-content_cat-heading__9ENzM"};